/* angular:styles/component:css;d8cc1635795d32db4168d7abeac21333746efed0e57fb2d0b29ab74448432b5c;C:\Projects\WebGalis-FE\src\app\navigation\components\wg-ai-panel\wg-ai-panel.component.ts */
:host {
  display: contents;
}
app-wg-ai-panel,
app-wg-ai-panel * {
  font-family: "Inter", sans-serif;
}
@keyframes dot-bounce {
  0%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-4px);
  }
}
.dot-1 {
  animation: dot-bounce 1.4s ease-in-out infinite;
}
.dot-2 {
  animation: dot-bounce 1.4s ease-in-out 0.2s infinite;
}
.dot-3 {
  animation: dot-bounce 1.4s ease-in-out 0.4s infinite;
}
/*# sourceMappingURL=wg-ai-panel.component.css.map */
